import {
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
  Align_Start_getInstance48vaevgl3nrq as Align_Start_getInstance,
  Align_Stretch_getInstance2huaa6rbagugp as Align_Stretch_getInstance,
  Align_End_getInstancer37lklmdzqms as Align_End_getInstance,
} from '../models/data.mjs';
import { align3syrmjzjb5jar as align } from './direct/modifiers.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_centered(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Center_getInstance(), Align_Center_getInstance());
}
function get_atStart(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Start_getInstance(), Align_Stretch_getInstance());
}
function get_atEnd(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_End_getInstance(), Align_Stretch_getInstance());
}
function get_atTopEnd(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_End_getInstance(), Align_Start_getInstance());
}
function get_atBottomCenter(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Center_getInstance(), Align_End_getInstance());
}
function get_atBottomStart(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Start_getInstance(), Align_End_getInstance());
}
function get_atBottom(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Stretch_getInstance(), Align_End_getInstance());
}
function get_atCenterEnd(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_End_getInstance(), Align_Center_getInstance());
}
function get_centeredVertically(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Stretch_getInstance(), Align_Center_getInstance());
}
function get_atTop(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Stretch_getInstance(), Align_Start_getInstance());
}
//region block: exports
export {
  get_atBottom as get_atBottom2b5zia3cn544c,
  get_atBottomCenter as get_atBottomCenter25gz8knna6ld8,
  get_atBottomStart as get_atBottomStart1iulwjfo1udg3,
  get_atCenterEnd as get_atCenterEnd393qzfpu2gjbc,
  get_atEnd as get_atEnd34105oxxaxc2o,
  get_atStart as get_atStart2tusd7ehy6hjj,
  get_atTop as get_atTopy2id3zo687kr,
  get_atTopEnd as get_atTopEnd2f4khbhwy0qa,
  get_centered as get_centered31th09q7x90sf,
  get_centeredVertically as get_centeredVertically612wtasps5l3,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
